<template>
	<div
		:class="`formulate-input-element formulate-input-element--${context.type}`"
		:data-type="context.type">
		<div class="row">
			<div class="col-lg-3">
				<FormulateInput
					v-model="context.model['country']"
					type="select"
					name="addr_country"
					input-class="custom-select"
					outer-class=""
					:options="countries"
					:label="showFieldLabels ? 'Country' : false"
					placeholder="Select Country --"
					validation="required"
					validation-name="Country" />
			</div>
			<div class="col-lg-3">
				<FormulateInput
					v-model="context.model['state']"
					type="select"
					name="addr_state"
					input-class="custom-select"
					outer-class=""
					:options="selectStates"
					:label="showFieldLabels ? 'State' : false"
					:placeholder="`Select ` + countryKey + ` --`"
					validation="required"
					validation-name="State" />
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'

export default {
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	computed: {
		...mapState({
			addressInit: state => state.init.address
		}),
		states () {
			return this.addressInit.states ?? {}
		},
		countries () {
			return this.addressInit[this.allowedCountries] ?? {}
		},
		countryKey () {
			if (! this.context.model.country || Object.keys(this.states).length <= 0) {
				return 'State'
			}

			return Object.keys(this.states[this.context.model.country])[0]
		},
		selectStates () {
			if (! this.context.model.country || Object.keys(this.states).length <= 0) {
				return
			}

			return this.states[this.context.model.country][this.countryKey]
		},
		showFieldLabels () {
			return this.context.labelPosition === 'fields'
		},
		allowedCountries () {
			if (this.context.attributes['all-countries'] === undefined) {
				return 'allowed_countries'
			}

			return this.context.attributes['all-countries'] === true ? 'countries' : 'allowed_countries'
		}
	},
	watch: {
		'context.model.country': {
			handler (newValue, oldValue) {
				if (newValue !== null) {
					this.context.model.state = null
				}
			}
		}
	},
	mounted () {
		if (Object.keys(this.countries) > 0) {
			return
		}

		if (typeof this.context.model !== 'object') {
			this.context.model = {
				country: null,
				state: null
			}
		}
	}
}
</script>
